import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography,} from '@mui/material';

/**
 * Confirmation dialog for folder deletion.
 */
const DeleteFolderDialog = ({open, folderName, onClose, onConfirm}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Delete folder?</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete "{folderName}" and all its contents?
                    This cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button color="error" onClick={onConfirm}>Delete</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteFolderDialog;
